var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRestore18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.695 2.624l1.414 1.414c2.743-2.743 7.237-2.687 9.912-.012 2.675 2.674 2.73 7.168 0 9.899-2.73 2.73-7.225 2.675-9.9 0l1.415-1.414c2.015 2.016 4.996 2.075 7.058.012 2.063-2.062 1.629-5.467.013-7.083-1.617-1.616-5.027-2.045-7.084.012l1.414 1.414L2 7.561l.695-4.937z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0yLjY5NSAyLjYyNGwxLjQxNCAxLjQxNGMyLjc0My0yLjc0MyA3LjIzNy0yLjY4NyA5LjkxMi0uMDEyIDIuNjc1IDIuNjc0IDIuNzMgNy4xNjggMCA5Ljg5OS0yLjczIDIuNzMtNy4yMjUgMi42NzUtOS45IDBsMS40MTUtMS40MTRjMi4wMTUgMi4wMTYgNC45OTYgMi4wNzUgNy4wNTguMDEyIDIuMDYzLTIuMDYyIDEuNjI5LTUuNDY3LjAxMy03LjA4My0xLjYxNy0xLjYxNi01LjAyNy0yLjA0NS03LjA4NC4wMTJsMS40MTQgMS40MTRMMiA3LjU2MWwuNjk1LTQuOTM3eiIvPjwvc3ZnPg==";
export { SvgRestore18 as ReactComponent };